import { useEffect, useRef } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { pushVirtualPageview } from '@/datalayer-events';
import { documentTitleForPath } from './use-document-title';

/**
 * EU-392 / DLR-001 — dispara `virtual_pageview` no dataLayer a cada mudança de
 * rota da SPA (substituindo o PageView nativo do GTM/GA4), com `page_path` e
 * `page_title`.
 *
 * IMPORTANTE: `page_path` e `page_title` derivam do MESMO `pathname` (router
 * state). Não lemos `window.location.pathname`/`document.title` aqui de propósito:
 * durante a navegação (redirect/Suspense) essas duas fontes externas atualizam em
 * momentos diferentes do `pathname` que dispara o efeito, e o evento saía com o
 * path de uma rota + o título de outra (off-by-one). Derivar ambos do `pathname`
 * garante que sempre casam. Um `ref` guarda o último pathname para não duplicar.
 */
export function useDataLayerPageview(): void {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (lastPathRef.current === pathname) return;
    lastPathRef.current = pathname;
    pushVirtualPageview(pathname, documentTitleForPath(pathname));
  }, [pathname]);
}
